export default __webpack_public_path__ + "static/media/dynamic_resources.20c7f5bc.png";